var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip-entrance"},[(_vm.isVip)?_c('ExclusivePakage'):_c('BuyVipEntrance')],1)}
var staticRenderFns = []

export { render, staticRenderFns }